module.exports = __webpack_public_path__ + "media/images/logo-7e4a87005ac8de05591b4dca2bcb2bb7.png";